/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CountriesService {
    /**
     * Get all countries
     * Retrieves all countries with calling codes, ordered by name
     * @returns any Countries retrieved successfully
     * @throws ApiError
     */
    public static getApiV2Countries(): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: Array<{
            /**
             * Two-letter country code (ISO 3166-1 alpha-2)
             */
            country_code?: string;
            /**
             * Country name
             */
            name?: string;
            /**
             * International calling code
             */
            calling_code?: string;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/countries',
        });
    }
    /**
     * Get states for a country
     * Retrieves all states for a specific country
     * @param countryCode Two-letter country code (e.g., 'US', 'CA')
     * @returns any States retrieved successfully
     * @throws ApiError
     */
    public static getApiV2CountriesStates(
        countryCode: string,
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: Array<{
            /**
             * Two-letter state/province code
             */
            state_code?: string;
            /**
             * State or province name
             */
            name?: string;
            /**
             * Two-letter country code (ISO 3166-1 alpha-2)
             */
            country_code?: string | null;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/countries/{countryCode}/states',
            path: {
                'countryCode': countryCode,
            },
        });
    }
}
